import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";
import { EditActions, editActions } from "../../actions/editActions";
import { hasWriteAccess, nameofFactory } from "../../utils/utils";
import Editor from "../../components/Editing/Editor";
import NumberField from "../../components/Editing/NumberField";
import TextField from "../../components/Editing/TextField";
import { Divider, Modal } from "semantic-ui-react";
import DropdownField from "../../components/Editing/DropdownField";
import { getcommonEnumOptions } from "../../utils/pdApiUtils";
import ButtonField from "../../components/Editing/ButtonField";
import { EditLocalizationStatus } from "./EditLocalizationStatus";
import TextIndicatorField from "../../components/Editing/TextIndicatorField";

type StateProps = {
  editedEscalatorEventLog: Api.EscalatorEventLog;
  storedEscalatorEventLog: Api.EscalatorEventLog;
  pdApi: State.PdApi;
  activeUser?: Api.User;
  columns: State.ColumnMap;
  isShortenTextEnabled: boolean;
};

type DispatchProps = {
  editActions: typeof editActions;
};

type OwnProps = {
  toggleModal: () => void;
};

export type EditEscalatorEventLogProps = StateProps & DispatchProps & OwnProps;

export type EditEscalatorEventLogState = {
  isEditLocalizationStatusOpen: boolean;
  locsOriginal: Api.LocsEscalatorEventLog[];
  locsEdited: Api.LocsEscalatorEventLog[];
};

const escalatorEventLogFields = nameofFactory<Api.EscalatorEventLog>();

export class EditEscalatorEventLog extends React.Component<
  EditEscalatorEventLogProps,
  EditEscalatorEventLogState
> {
  constructor(props: EditEscalatorEventLogProps) {
    super(props);
    this.state = {
      isEditLocalizationStatusOpen: false,
      locsOriginal: [],
      locsEdited: []
    };
  }
  public render(): JSX.Element {
    const { isEditLocalizationStatusOpen } = this.state;
    const {
      editedEscalatorEventLog,
      storedEscalatorEventLog,
      activeUser,
      columns,
      pdApi,
      toggleModal,
      isShortenTextEnabled
    } = this.props;

    const isNew = !storedEscalatorEventLog;
    const escalatorData1Options = getcommonEnumOptions(pdApi.enumerations, "E_additionalData1");
    const escalatorData2Options = getcommonEnumOptions(pdApi.enumerations, "E_additionalData2");
    const permissions = hasWriteAccess(activeUser, "Escalator");

    return (
      <Editor
        itemName={"escalator event log"}
        originalObject={storedEscalatorEventLog}
        editedObject={editedEscalatorEventLog}
        hasWritePermission={hasWriteAccess(activeUser, "Escalator")}
        isValid={this.isAllFieldsValid()}
        cancel={this.props.editActions.cancelEditing}
        update={() => {
          this.props.editActions.setEdited({
            ...editedEscalatorEventLog,
            locs: this.state.locsEdited
          });
          this.props.editActions.update("escalatorEventLogs");
        }}
        create={() => {
          this.props.editActions.setEdited({
            ...editedEscalatorEventLog,
            locs: this.state.locsEdited
          });
          this.props.editActions.add("escalatorEventLogs");
        }}
        copy={() => {
          this.props.editActions.setEdited({
            ...editedEscalatorEventLog,
            locs: this.state.locsEdited
          });
          this.props.editActions.startEditing(editedEscalatorEventLog, true);
        }}
        remove={{ callback: toggleModal }}
      >
        <NumberField
          id="eventcode"
          label="Event Code"
          value={editedEscalatorEventLog.eventCode}
          isError={!this.isFieldValid(escalatorEventLogFields("eventCode"))}
          errorMessage="The event code must be unique."
          readonly={!isNew}
          onChange={eventCode => this.props.editActions.setEdited({ ...editedEscalatorEventLog, eventCode })}
        />
        <TextField
          id="eventName"
          label="Event Name"
          value={editedEscalatorEventLog.eventName}
          isError={!this.isFieldValid(escalatorEventLogFields("eventName"))}
          errorMessage={
            !this.isEmptyString(editedEscalatorEventLog.eventName) ? "The event name must be unique." : ""
          }
          onChange={eventName =>
            this.props.editActions.setEdited({ ...editedEscalatorEventLog, eventName: eventName.trim() })
          }
          readonly={!permissions}
        />
        <Divider horizontal={true}>{"Additional Data1 properties"}</Divider>
        <DropdownField
          id="escalatorData1"
          label="Additional Data1" //mention when data1 changes entered unit will go away.its needed when user enter value and seelectes no and iimdiate option
          value={editedEscalatorEventLog.data1EnumValue}
          options={escalatorData1Options}
          search={true}
          onChange={data1 => {
            this.props.editActions.setEdited({
              ...editedEscalatorEventLog,
              data1EnumValue: data1,
              data1EnumName: getcommonEnumOptions(pdApi.enumerations, "E_additionalData1").find(
                item => item.key === data1
              )?.text?.replace(` [${data1}]`, "").trim() || "",
              data1UnitName: "",
              data1DecimalDigits: 0
            });
          }}
          disabled={!permissions}
        />
        {editedEscalatorEventLog.data1EnumValue !== 0 && (
        <>
            <TextField
            id="escalatorData1UnitName"
            label="Unit Name"
            value={editedEscalatorEventLog.data1UnitName}
            isError={!this.isFieldValid(escalatorEventLogFields("data1UnitName"))}
            onChange={unitName => this.props.editActions.setEdited({ ...editedEscalatorEventLog, data1UnitName: unitName.trim() })
            }
            readonly={!permissions}
            />
            <NumberField
            id="escalatorData1DecimalDigits"
            label="Decimal Digits"
            value={editedEscalatorEventLog.data1DecimalDigits}
            isError={false}
            errorMessage="The decimal digits must be a valid number."
            readonly={!permissions}
            onChange={decimaldigit => this.props.editActions.setEdited({ ...editedEscalatorEventLog, data1DecimalDigits: decimaldigit })}
            />
        </>
        )
        }
        <Divider horizontal={true}>{"Additional Data2 properties"}</Divider>
        <DropdownField
          id="escalatorData2"
          label="Additional Data2"
          value={editedEscalatorEventLog.data2EnumValue}
          options={escalatorData2Options}
          search={true}
          onChange={data2 => {
            this.props.editActions.setEdited({
              ...editedEscalatorEventLog,
              data2EnumValue: data2,
              data2EnumName: getcommonEnumOptions(pdApi.enumerations, "E_additionalData2").find(
                item => item.key === data2
              )?.text?.replace(` [${data2}]`, "").trim() || "",
              data2UnitName: "",
              data2DecimalDigits: 0
            });
          }}
          disabled={!permissions}
        />
        {editedEscalatorEventLog.data2EnumValue !== 0 && (
        <>
            <TextField
            id="escalatorData2UnitName"
            label="Unit Name"
            value={editedEscalatorEventLog.data2UnitName}
            isError={false}
            onChange={unitName => this.props.editActions.setEdited({ ...editedEscalatorEventLog, data2UnitName: unitName.trim() })
            }
            readonly={!permissions}
            />
            <NumberField
            id="escalatorData2DecimalDigits"
            label="Decimal Digits"
            value={editedEscalatorEventLog.data2DecimalDigits}
            isError={!this.isFieldValid(escalatorEventLogFields("data2DecimalDigits"))}
            errorMessage="The decimal digits must be a valid number."
            readonly={!permissions}
            onChange={decimaldigit => this.props.editActions.setEdited({ ...editedEscalatorEventLog, data2DecimalDigits: decimaldigit })}
            />
        </>
        )
        }
        <Divider horizontal={true}>{"English translations"}</Divider>
        <TextIndicatorField
          id={"needsUpdateIndicator"}
          text={"Edited texts will be translated."}
          isWarning={this.englishTranslationsChanged()}
        />
        <TextField
          id="name"
          label="English Name"
          value={editedEscalatorEventLog.name}
          isError={!this.isFieldValid(escalatorEventLogFields("name"))}
          onChange={value => {
            this.props.editActions.setEdited({
              ...editedEscalatorEventLog,
              name: value.trim()
            } as Api.EscalatorEventLog);
          }}
          readonly={!permissions}
        />
        <TextField
          id="description"
          label="Description"
          value={editedEscalatorEventLog.description}
          isError={!this.isFieldValid(escalatorEventLogFields("description"))}
          onChange={value => {
            this.props.editActions.setEdited({
              ...editedEscalatorEventLog,
              description: value.trim()
            } as Api.EscalatorEventLog);
          }}
          readonly={!permissions}
        />
        <ButtonField
          id={"viewTranslationsButton"}
          label="View translations"
          onButtonClick={this.toggleEditLocalizationStatusModal}
        />
        <Modal size="large" open={isEditLocalizationStatusOpen} className="data-sections-modal">
          <EditLocalizationStatus
            itemType={"Escalator Event Log"}
            editedItem={{ ...editedEscalatorEventLog, locs: this.state.locsEdited }}
            getOption="escalatorEventLogLocalizations"
            columns={columns["Escalator Event Log Localization Status"]}
            pdApi={pdApi}
            toggleEditLocalizationStatusModal={this.toggleEditLocalizationStatusModal}
            setLocalizationsEdited={this.setLocalizationsEdited}
            isShortenTextEnabled={isShortenTextEnabled}
            englishTranslationChanged={this.englishTranslationsChanged()}
            userPermissions={permissions}
            locsOriginal={this.state.locsOriginal || []}
            setLocalizationsNonEdited={this.setLocalizationsNonEdited}
          />
        </Modal>
      </Editor>
    );
  }

  private englishTranslationsChanged = (): boolean =>
    this.props.editedEscalatorEventLog.name !== this.props.storedEscalatorEventLog?.name ||
    this.props.editedEscalatorEventLog.description !== this.props.storedEscalatorEventLog?.description;

  private handleEnglishTranslationsChange(item: Api.EscalatorEventLog) {
    const { storedEscalatorEventLog, editedEscalatorEventLog } = this.props;
    const { locsOriginal, locsEdited } = this.state;

    // create both edited and stored item locs if needed
    const edited =
      locsEdited.length === 0
        ? [
            {
              text: item.name,
              description: item.description,
              localeNavigation: { locale: "en-US" }
            } as Api.LocsEscalatorEventLog
          ]
        : this.state.locsEdited.map(loc => {
            if (loc.localeNavigation.locale === "en-US") {
              return {
                ...loc,
                text: item.name,
                description: item.description
              } as Api.LocsEscalatorEventLog;
            } else {
              return loc;
            }
          });
    const original =
      locsOriginal.length === 0
        ? [
            {
              text: storedEscalatorEventLog?.name,
              description: storedEscalatorEventLog?.description,
              localeNavigation: { locale: "en-US" }
            } as Api.LocsEscalatorEventLog
          ]
        : locsOriginal;

    this.setState((prevState: EditEscalatorEventLogState) => ({
      ...prevState,
      locsEdited: edited,
      locsOriginal: original
    }));
    this.props.editActions.setEdited({
      ...editedEscalatorEventLog,
      name: item.name,
      description: item.description
    });
  }

  private toggleEditLocalizationStatusModal = (): void => {
    this.setState((prevState: EditEscalatorEventLogState) => ({
      ...prevState,
      isEditLocalizationStatusOpen: !prevState.isEditLocalizationStatusOpen
    }));
  };

  private setLocalizationsEdited = (
    newLocalizations: Api.LocsEscalatorEventLog[],
    oldLocalizations: Api.LocsEscalatorEventLog[]
  ): void => {
    const { editedEscalatorEventLog } = this.props;
    this.setState((prevState: EditEscalatorEventLogState) => ({
      ...prevState,
      locsEdited: newLocalizations,
      locsOriginal: oldLocalizations
    }));
    this.props.editActions.setEdited({
      ...editedEscalatorEventLog,
      name:
        newLocalizations.find(loc => loc.localeNavigation.locale === "en-US")?.text ||
        editedEscalatorEventLog?.name,
      description:
        newLocalizations.find(loc => loc.localeNavigation.locale === "en-US")?.description ||
        editedEscalatorEventLog?.description,
      locs: newLocalizations
    } as Api.EscalatorEventLog);
  };

  private setLocalizationsNonEdited = (Localizations: Api.LocsEscalatorEventLog[]): void => {
    this.setState((prevState: EditEscalatorEventLogState) => ({
      ...prevState,
      locsOriginal: Localizations
    }));
  };
  private isFieldValid = (field: string): boolean => {
    const { editedEscalatorEventLog, storedEscalatorEventLog, pdApi } = this.props;
    if (!Number.isInteger(editedEscalatorEventLog.eventCode)) return false;
    const isNew = !storedEscalatorEventLog;
    switch (field) {
      case escalatorEventLogFields("eventCode"):
        return _.values(pdApi.escalatorEventLogs).find(
          escalatorEventLog =>
            (isNew || escalatorEventLog.id !== editedEscalatorEventLog.id) &&
            escalatorEventLog.eventCode === editedEscalatorEventLog.eventCode
        )
          ? false
          : true;
      case escalatorEventLogFields("eventName"): {
        const { eventName } = editedEscalatorEventLog;
        if (this.isEmptyString(eventName)) {
          return false;
        } else {
          return _.values(pdApi.escalatorEventLogs).find(
            escalatorEventLog =>
              (isNew || escalatorEventLog.id !== editedEscalatorEventLog.id) &&
              escalatorEventLog.eventName?.trim().toLowerCase() ===
                editedEscalatorEventLog.eventName?.trim().toLowerCase()
          )
            ? false
            : true;
        }
      }
      case escalatorEventLogFields("name"): {
        const { name } = editedEscalatorEventLog;
        return !this.isEmptyString(name);
      }
      case escalatorEventLogFields("description"): {
        const { description } = editedEscalatorEventLog;
        return !this.isEmptyString(description);
      }
      default:
        return true;
    }
  };

  private isEmptyString = (str: string): boolean => !(!!str.trim() && str.trim().length > 0);

  private isAllFieldsValid = (): boolean => {
    const { editedEscalatorEventLog } = this.props;
    const temp = _.keys(editedEscalatorEventLog);
    for (const key of temp) {
      if (!this.isFieldValid(key)) {
        return false;
      }
    }
    return true;
  };
}

const mapStateToProps = (state: State.Root) => ({
  editedEscalatorEventLog: state.editView.editedObject,
  storedEscalatorEventLog: state.editView.storedObject,
  pdApi: state.pdApi,
  activeUser: state.main.activeUser,
  isShortenTextEnabled: state.main.isShortenTextEnabled
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEscalatorEventLog);
